import axios from 'axios'
import { setAuthorization } from './general'

export function login (credentials) {
  return new Promise((resolve, reject) => {
    axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
    axios.post(
      process.env.ROOT_API + '/api/auth/login',
      credentials
    )
      .then(
        (response) => {
          setAuthorization(response.data.access_token)
          resolve(response.data)
        }
      )
      .catch((err) => {
        console.log('hubo un error')
        console.log(err)
        reject(err)
      })
  })
}

export function getLocalUser () {
  const userStr = localStorage.getItem('user')

  if (!userStr) {
    return null
  }

  return JSON.parse(userStr)
}



// WEBPACK FOOTER //
// ./src/helpers/auth.js